import { forwardRef } from 'react';
import { useAsyncFn } from 'react-use';

import { Button } from '../../../../components/Button/Button';
import { Typography } from '../../../../components/Typography/Typography';

import { ConfirmIcon } from './Confirm.types';
import { CONFIRM_ICON } from './Confirm.const';

import styles from './Confirm.module.scss';

export interface ConfirmProps {
  icon: ConfirmIcon;
  confirmText: string;
  cancelText: string;
  message: string;
  onConfirm: () => Promise<unknown>;
  dissmiss: () => void;
}

export const Confirm = forwardRef<HTMLDivElement, ConfirmProps>(
  ({ onConfirm, confirmText, cancelText, message, icon, dissmiss }, ref) => {
    const [{ loading }, confirm] = useAsyncFn(async () => {
      return onConfirm();
    }, [onConfirm]);

    const handleOnConfirm = () => {
      confirm().finally(dissmiss);
    };

    const handleOnCancel = () => {
      dissmiss();
    };

    return (
      <div ref={ref} className={styles.root}>
        <div className={styles.header}>
          <Button
            size="s"
            icon="close"
            block={false}
            variant="text"
            onClick={handleOnCancel}
          />
        </div>
        <div className={styles.content}>
          <img alt="" src={CONFIRM_ICON[icon]} className={styles.icon} />
          <Typography variant="p1" align="center">
            {message}
          </Typography>
        </div>
        <div className={styles.actions}>
          <Button block={false} variant="secondary" onClick={handleOnCancel}>
            {cancelText}
          </Button>
          <Button
            block={false}
            variant="primary"
            loading={loading}
            onClick={handleOnConfirm}
          >
            {confirmText}
          </Button>
        </div>
      </div>
    );
  }
);
